export default {
  POLITE: "Sie",
  NORMAL: "Du"
};
